export default {"src":"/_next/static/media/white-bath.e0a32521.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};